import { useState, useRef, useEffect } from "react";

const ProductDropdown = ({ products, selectedProduct, setSelectedProduct }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);

  const selectedItem = products.find(p => p._id === selectedProduct);

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(search.toLowerCase())
  );

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mb-4 relative" ref={wrapperRef}>
      <label className="block text-sm font-medium mb-1">Product</label>

      <div
        className="border rounded-lg py-2 px-3 cursor-pointer bg-white"
        onClick={() => setOpen(!open)}
      >
        {selectedItem
          ? `${selectedItem.name} (₹${selectedItem.price})`
          : "Search or select a product..."}
      </div>

      {open && (
        <div className="absolute z-10 bg-white border rounded-lg w-full mt-1 shadow-lg">
          <input
            type="text"
            placeholder="Search product..."
            className="w-full px-3 py-2 border-b outline-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className="max-h-60 overflow-y-auto">
            <div
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                setSelectedProduct("custom");
                setOpen(false);
              }}
            >
              Custom Product
            </div>

            {filteredProducts.map(product => (
              <div
                key={product._id}
                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setSelectedProduct(product._id);
                  setOpen(false);
                }}
              >
                {product.name} (₹{product.price})
              </div>
            ))}

            {filteredProducts.length === 0 && (
              <div className="px-3 py-2 text-gray-500">
                No products found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDropdown;
